export const handleChangeDataVipServicesPage = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_VIP_SERVICES', name, value
});